// extracted by mini-css-extract-plugin
export default {"title":"AuthorForm_title__z1vYL","authorForm":"AuthorForm_authorForm__g4Gib","checkBox":"AuthorForm_checkBox__BNSuP","linkWordButton":"AuthorForm_linkWordButton__3L7Jt"};